/** Apply KOT brand theme from admin kot-configuration (CSS variables). */
export const DEFAULT_THEME_PRIMARY = '#512d82';

export function normalizeHexColor(value) {
  if (value == null || String(value).trim() === '') {
    return DEFAULT_THEME_PRIMARY;
  }
  let s = String(value).trim();
  if (!s.startsWith('#')) s = `#${s}`;
  if (/^#[0-9A-Fa-f]{6}$/i.test(s)) return s.toLowerCase();
  if (/^#[0-9A-Fa-f]{3}$/i.test(s)) {
    const h = s.slice(1);
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toLowerCase();
  }
  return DEFAULT_THEME_PRIMARY;
}

function hexToRgb(hex) {
  const n = normalizeHexColor(hex).slice(1);
  return {
    r: parseInt(n.slice(0, 2), 16),
    g: parseInt(n.slice(2, 4), 16),
    b: parseInt(n.slice(4, 6), 16),
  };
}

function rgbToHex(r, g, b) {
  const clamp = (x) => Math.max(0, Math.min(255, Math.round(x)));
  const to = (x) => clamp(x).toString(16).padStart(2, '0');
  return `#${to(r)}${to(g)}${to(b)}`;
}

/** percent: negative = darker, positive = lighter */
function adjustBrightness(hex, percent) {
  const { r, g, b } = hexToRgb(hex);
  const factor = 1 + percent / 100;
  return rgbToHex(r * factor, g * factor, b * factor);
}

export function applyKotTheme(primaryHex) {
  if (typeof document === 'undefined') return;
  const primary = normalizeHexColor(primaryHex);
  const hover = adjustBrightness(primary, -18);
  const light = adjustBrightness(primary, 22);
  const mid = adjustBrightness(primary, -8);
  const dark = adjustBrightness(primary, -35);
  const { r, g, b } = hexToRgb(primary);
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', primary);
  root.style.setProperty('--brand-primary-hover', hover);
  root.style.setProperty('--brand-primary-light', light);
  root.style.setProperty('--brand-primary-mid', mid);
  root.style.setProperty('--brand-primary-dark', dark);
  root.style.setProperty('--brand-primary-muted', `rgba(${r}, ${g}, ${b}, 0.1)`);
  root.style.setProperty('--brand-primary-fade-12', `rgba(${r}, ${g}, ${b}, 0.12)`);
  root.style.setProperty('--brand-primary-fade-20', `rgba(${r}, ${g}, ${b}, 0.2)`);
  root.style.setProperty('--brand-primary-border', `rgba(${r}, ${g}, ${b}, 0.28)`);
  root.style.setProperty('--brand-shadow-sm', `rgba(${r}, ${g}, ${b}, 0.2)`);
  root.style.setProperty('--brand-shadow-md', `rgba(${r}, ${g}, ${b}, 0.28)`);
  const themeMeta = document.querySelector('meta[name="theme-color"]');
  if (themeMeta) themeMeta.setAttribute('content', primary);
}

/** Inline styles for vue-slider / range components tied to admin theme. */
export function getBrandSliderStyles(primaryHex) {
  const primary = normalizeHexColor(primaryHex);
  return {
    processStyle: { backgroundColor: primary },
    tooltipStyle: {
      backgroundColor: primary,
      borderColor: primary,
    },
  };
}
